import { computed } from 'vue'

import type { AuthStoreValuesType } from './auth.store'

export function selectGetAuthToken(state: AuthStoreValuesType) {
  return state.authToken
}

export function selectGetUserActivePermissionGroup(state: AuthStoreValuesType) {
  return computed(() => state.userActivePermissionGroup)
}
